/**
 * マニフェスト管理 処分終了報告
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/rest_manifests`

const rest_manifest_disposal = {

  namespaced: true,
  actions: {
    /**
     * 紙・Web処分報告の修正
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}/disposals`
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    /**
     * 紙・Web処分報告の取消
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    destroy ({ commit }, { id }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}/disposals`
        Vue.$http.delete(api_path).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '取消しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}

export default rest_manifest_disposal
